import { useFavourites } from './Favourites/use';
import { useTeammateProfile } from '@web/store/Teammate/TeammateProfile';
import { useUser } from '@clerk/nextjs';
import React from 'react';

// Triggers a re-hydration of user-scoped Zustand stores once Clerk has loaded
// the user. Without this, the persist middleware reads localStorage during app
// boot — at which point the Clerk userId isn't yet available, so the scoped key
// resolves to nothing and stores start empty. Mount this inside the signed-in
// scope; it runs once per session per signed-in user.
function FilterStoresRehydrator() {
  const { user, isLoaded } = useUser();
  const userId = user?.id;

  React.useEffect(() => {
    if (!isLoaded || !userId) return;
    void useFavourites.persist.rehydrate();
    useTeammateProfile.persist.rehydrate();
  }, [isLoaded, userId]);

  return null;
}

export { FilterStoresRehydrator };
